// Dedicated calendar item endpoints (services/events/blockouts).
// These wrap the backend POST/PUT routes which trigger Calendar-section
// push notifications for newly-affected users (diff-based on update).
// They replace the bulk PUT /storage/{key} write path for single-item
// create + update operations.

import { API_BASE, authHeaders } from "./apiClient";

async function _send(method, path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `${method} ${path} failed (${res.status})`);
  }
  return res.json();
}

export const apiCreateService  = (svc)       => _send("POST", "/services", svc);
export const apiUpdateService  = (id, svc)   => _send("PUT",  `/services/${id}`, svc);
export const apiDeleteService  = (id)        => _send("DELETE", `/services/${id}`);
export const apiCreateEvent    = (evt)       => _send("POST", "/events", evt);
export const apiUpdateEvent    = (id, evt)   => _send("PUT",  `/events/${id}`, evt);
export const apiDeleteEvent    = (id)        => _send("DELETE", `/events/${id}`);
export const apiCreateBlockout = (bo)        => _send("POST", "/blockouts", bo);
export const apiUpdateBlockout = (id, bo)    => _send("PUT",  `/blockouts/${id}`, bo);
export const apiDeleteBlockout = (id)        => _send("DELETE", `/blockouts/${id}`);
